<!-- Sidebar -->
    <!-- Sidebar Primary -->
    <div class="flex flex-col items-stretch shrink-0 gap-5 py-5 w-[70px] border-e border-input" id="sidebar_primary">
        <div class="hidden lg:flex items-center justify-center shrink-0" id="sidebar_primary_header">
            <a href="#">
                <img class="dark:hidden min-h-[30px]" src="assets/media/app/mini-logo-gray.svg"/>
                <img class="hidden dark:block min-h-[30px]" src="assets/media/app/mini-logo-gray-dark.svg"/>
            </a>
        </div>
        <div class="flex grow shrink-0" id="sidebar_primary_content">
            <div class="kt-scrollable-y-hover grow gap-2.5 shrink-0 flex ps-4 flex-col" data-kt-scrollable="true" data-kt-scrollable-dependencies="#sidebar_primary_header,#sidebar_primary_footer" data-kt-scrollable-height="auto" data-kt-scrollable-offset="80px" data-kt-scrollable-wrappers="#sidebar_primary_content">
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-chart-line-star text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Dashboard
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-profile-circle text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Profile
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-setting-2 text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Account
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-users text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Network
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-security-user text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Authentication
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-handcart text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Store - Client
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-shop text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Security Logs
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-cheque text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    Notifications
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-code text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    ACL
                    </span>
                </a>
                <a class="kt-btn kt-btn-icon kt-btn-ghost rounded-md size-9 border border-transparent hover:bg-background hover:[&_i]:text-primary hover:border-border [.active&]:bg-background [.active&]:[&_i]:text-primary [.active&]:border-border" data-kt-tooltip="" data-kt-tooltip-placement="right" href="#">
                    <span class="kt-menu-icon">
                    <i class="ki-filled ki-question text-lg">
                    </i>
                    </span>
                    <span class="kt-tooltip" data-kt-tooltip-content="true">
                    API Keys
                    </span>
                </a>
            </div>
        </div>
        <div class="flex flex-col gap-5 items-center shrink-0" id="sidebar_primary_footer">
            <div class="flex flex-col gap-1.5">
                <app-topbar-chat></app-topbar-chat>
                <app-topbar-apps></app-topbar-apps>
            </div>
            <app-topbar-user-dropdown></app-topbar-user-dropdown>
        </div>
    </div>
    <!-- End of Sidebar Primary -->
    <!-- Sidebar Secondary -->
    <div class="flex items-stretch grow shrink-0 justify-center ps-1.5 my-5 me-1.5" id="sidebar_secondary">
        <div class="kt-scrollable-y-auto grow" data-kt-scrollable="true" data-kt-scrollable-height="auto" data-kt-scrollable-offset="0px" data-kt-scrollable-wrappers="#sidebar_secondary">
            <!-- Sidebar Menu -->
            <div class="kt-menu flex flex-col w-full gap-px px-2.5" data-kt-menu="true" data-kt-menu-accordion-expand-all="false" id="sidebar_menu">
                <div class="kt-menu-item" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
                    <div class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
                        Account Home
                    </span>
                    <span class="kt-menu-arrow text-muted-foreground">
                        <span class="inline-flex kt-menu-item-show:hidden">
                        <i class="ki-filled ki-down text-xs">
                        </i>
                        </span>
                        <span class="hidden kt-menu-item-show:inline-flex">
                        <i class="ki-filled ki-up text-xs">
                        </i>
                        </span>
                    </span>
                    </div>
                    <div class="kt-menu-accordion gap-px">
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Get Started
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            User Profile
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Company Profile
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Settings - With Sidebar
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Settings - Enterprise
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Settings - Plain
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Settings - Modal
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
                <div class="kt-menu-item" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
                    <div class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
                        Billing
                    </span>
                    <span class="kt-menu-arrow text-muted-foreground">
                        <span class="inline-flex kt-menu-item-show:hidden">
                        <i class="ki-filled ki-down text-xs">
                        </i>
                        </span>
                        <span class="hidden kt-menu-item-show:inline-flex">
                        <i class="ki-filled ki-up text-xs">
                        </i>
                        </span>
                    </span>
                    </div>
                    <div class="kt-menu-accordion gap-px">
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Billing - Basic
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Billing - Enterprise
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Plans
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Billing History
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
                <div class="kt-menu-item" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
                    <div class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
                        Security
                    </span>
                    <span class="kt-menu-arrow text-muted-foreground">
                        <span class="inline-flex kt-menu-item-show:hidden">
                        <i class="ki-filled ki-down text-xs">
                        </i>
                        </span>
                        <span class="hidden kt-menu-item-show:inline-flex">
                        <i class="ki-filled ki-up text-xs">
                        </i>
                        </span>
                    </span>
                    </div>
                    <div class="kt-menu-accordion gap-px">
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Get Started
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Security Overview
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Allowed IP Addresses
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Privacy Settings
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Device Management
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Backup & Recovery
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Current Sessions
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Security Log
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
                <div class="kt-menu-item" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
                    <div class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-here:text-mono kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
                        Members & Roles
                    </span>
                    <span class="kt-menu-arrow text-muted-foreground">
                        <span class="inline-flex kt-menu-item-show:hidden">
                        <i class="ki-filled ki-down text-xs">
                        </i>
                        </span>
                        <span class="hidden kt-menu-item-show:inline-flex">
                        <i class="ki-filled ki-up text-xs">
                        </i>
                        </span>
                    </span>
                    </div>
                    <div class="kt-menu-accordion gap-px">
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Teams Starter
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Teams
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Team Info
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Members Starter
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Team Members
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Import Members
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Roles
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Permissions - Toggler
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Permissions - Check
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
                <div class="kt-menu-item">
                    <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                        Integrations
                    </span>
                    </a>
                </div>
                <div class="kt-menu-item">
                    <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                        Notifications
                    </span>
                    </a>
                </div>
                <div class="kt-menu-item">
                    <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                    <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                        API Keys
                    </span>
                    </a>
                </div>
                <div class="kt-menu-item flex-col-reverse" data-kt-menu-item-toggle="accordion" data-kt-menu-item-trigger="click">
                    <div class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent">
                    <span class="kt-menu-title text-sm text-secondary-foreground kt-menu-link-hover:text-mono">
                        <span class="hidden kt-menu-item-show:!flex">
                        Show less
                        </span>
                        <span class="flex kt-menu-item-show:hidden">
                        Show 3 more
                        </span>
                    </span>
                    <span class="kt-menu-arrow text-muted-foreground">
                        <span class="inline-flex kt-menu-item-show:hidden">
                        <i class="ki-filled ki-down text-xs">
                        </i>
                        </span>
                        <span class="hidden kt-menu-item-show:inline-flex">
                        <i class="ki-filled ki-up text-xs">
                        </i>
                        </span>
                    </span>
                    </div>
                    <div class="kt-menu-accordion gap-px">
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Appearance
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Invite a Friend
                        </span>
                        </a>
                    </div>
                    <div class="kt-menu-item">
                        <a class="kt-menu-link py-2 ps-2.5 pe-2.5 rounded-md border border-transparent kt-menu-item-active:border-border kt-menu-item-active:bg-background kt-menu-link-hover:bg-background kt-menu-link-hover:border-border" href="#">
                        <span class="kt-menu-title text-sm text-foreground kt-menu-item-active:font-medium kt-menu-item-active:text-primary kt-menu-link-hover:text-primary">
                            Activity
                        </span>
                        </a>
                    </div>
                    </div>
                </div>
            </div>
            <!-- End of Sidebar Menu -->
        </div>
    </div>
    <!-- End of Sidebar Secondary-->

<!-- End of Sidebar -->